import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowRight, ArrowLeft, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";
import SEO from "../components/SEO";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/password-reset", { email });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Něco se pokazilo, zkuste to znovu");
    } finally { setLoading(false); }
  };

  return (
    <div className="pt-10 pb-20 px-4 min-h-screen" data-testid="forgot-password-page">
      <SEO title="Zapomenuté heslo" noindex />
      <div className="max-w-md mx-auto">
        <Link to="/prihlaseni" className="inline-flex items-center gap-1.5 text-xs text-zinc-500 hover:text-zinc-900 mb-6" data-testid="back-to-login">
          <ArrowLeft className="w-3.5 h-3.5"/> Zpět na přihlášení
        </Link>
        <div className="text-center mb-8">
          <h1 className="font-display text-3xl font-bold">Zapomenuté heslo</h1>
          <p className="text-zinc-600 mt-2 text-sm">
            {sent ? "Pokud k zadanému e-mailu existuje účet, instrukce už letí." : "Zadejte svůj e-mail a pošleme vám odkaz pro obnovu hesla."}
          </p>
        </div>
        {sent ? (
          <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-7 text-center" data-testid="reset-sent-message">
            <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3"/>
            <p className="text-sm text-emerald-800 font-medium mb-1">Odesláno na <strong>{email}</strong></p>
            <p className="text-xs text-emerald-700">Odkaz platí 1 hodinu. Pokud e-mail nedorazil, zkontrolujte i složku Spam.</p>
            <Link to="/prihlaseni" className="inline-block mt-5 text-blue-600 text-sm font-semibold hover:underline">Zpět na přihlášení</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white rounded-2xl border border-zinc-200 p-7 space-y-4">
            <div>
              <label className="text-xs font-semibold text-zinc-600">E-mail</label>
              <div className="relative mt-1">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-zinc-400"/>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email"
                  className="w-full pl-10 pr-3 py-2.5 rounded-xl border border-zinc-200 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500"/>
              </div>
            </div>
            <button type="submit" disabled={loading} className="btn-primary w-full py-3 rounded-full font-semibold" data-testid="forgot-submit">
              {loading ? "Odesílání…" : <span className="inline-flex items-center justify-center gap-2">Poslat odkaz <ArrowRight className="w-4 h-4"/></span>}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
